import * as React from "react";

function SvgApteligent(props, ref) {
  return (
    <svg
      id="Apteligent_svg__Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 204.05 170.81"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <defs>
        <style>{".Apteligent_svg__cls-1{fill:#369}"}</style>
      </defs>
      <path
        className="Apteligent_svg__cls-1"
        d="M237.22 316.38q-.22-2.41-.64-4.75c-4.19-23.12-23.11-40.63-45.76-40.63-25.71 0-46.62 22.55-46.62 50.27s20.91 50.27 46.62 50.27c14.35 0 27.2-7 35.76-18.06v17.82h10.7c0-54.21 0-54.21-.06-54.92zm-46.4 44.46c-19.81 0-35.92-17.75-35.92-39.57s16.1-39.57 35.92-39.57 35.92 17.75 35.92 39.57c0 1.21-.06 2.4-.15 3.58v.15c-1.72 20.07-17.11 35.84-35.77 35.84z"
        transform="translate(-91.92 -195.23)"
      />
      <path
        className="Apteligent_svg__cls-1"
        d="M247.81 291a5.92 5.92 0 01-5.05-2.82c-12.62-20.5-30.6-31.34-52-31.34-28.92 0-45.18 19.4-52.29 31a5.93 5.93 0 01-10.1-6.21 81.94 81.94 0 0123.28-24.71A68.44 68.44 0 01190.78 245c25.35 0 47.39 13.13 62.07 37a5.93 5.93 0 01-5.04 9z"
        transform="translate(-91.92 -195.23)"
      />
      <path
        className="Apteligent_svg__cls-1"
        d="M266.63 272.3a5.92 5.92 0 01-4.9-2.58c-8-11.72-31-39-70.66-39-30.12 0-52.92 12.26-71.76 38.59a5.93 5.93 0 01-9.64-6.9c21-29.3 47.58-43.54 81.4-43.55 45.34 0 71.36 30.86 80.45 44.12a5.93 5.93 0 01-4.89 9.32z"
        transform="translate(-91.92 -195.23)"
        opacity={0.7}
      />
      <path
        className="Apteligent_svg__cls-1"
        d="M283.06 255.87a5.92 5.92 0 01-5-2.71c-13.75-21.26-44.87-46.08-87.3-46.08-51.58 0-78.75 31.81-88 45.49a5.93 5.93 0 11-9.81-6.66c10.35-15.24 40.59-50.68 97.84-50.68 47.19 0 81.88 27.74 97.25 51.49a5.93 5.93 0 01-4.98 9.15z"
        transform="translate(-91.92 -195.23)"
        opacity={0.35}
      />
    </svg>
  );
}

export default React.forwardRef(SvgApteligent);
